import React, { Children, useCallback } from 'react';
import { useDropdown } from '../useDropdown';

const DropdownTrigger = ({ children }) => {
  const { toggle, triggerRef } = useDropdown();
  const child = Children.only(children);

  const onClick = useCallback(
    (e) => {
      child.props.onClick?.(e);
      toggle();
    },
    [child.props, toggle],
  );

  const ref = useCallback(
    (node) => {
      triggerRef.current = node;
      if (typeof child.ref === 'function') {
        child.ref(node);
      } else if (child.ref) {
        child.ref.current = node;
      }
    },
    [child, triggerRef],
  );

  return React.cloneElement(child, { onClick, ref });
};

export default DropdownTrigger;
